export const shadow = {
  xs: "0px 1px 2px rgba(24, 27, 37, 0.08)",
  sm: "0px 4px 8px rgba(24, 27, 37, 0.08)",
  md: "0px 6px 12px rgba(24, 27, 37, 0.08)",
  lg: "0px 8px 16px rgba(24, 27, 37, 0.08)",
  xl: "0px 16px 24px rgba(24, 27, 37, 0.08)",
} as const;

export type Shadow = typeof shadow;